const loginSelectors = {
  recoverPasswordFormTriggers: '[data-recover-toggle]',
  recoverPasswordForm: '[data-recover-form]',
  loginForm: '[data-login-form]',
  formState: '[data-recover-form-state]',
  resetSuccess: '[data-reset-success]',
};

function onShowHidePasswordForm(evt) {
  evt.preventDefault();
  toggleRecoverPasswordForm();
}

function checkUrlHash() {
  const hash = window.location.hash;
  // Allow deep linking to recover password form
  if (hash === '#recover') {
    toggleRecoverPasswordForm();
  }
}

/**
 *  Show/Hide recover password form
 */
function toggleRecoverPasswordForm() {
  document
    .querySelector(loginSelectors.recoverPasswordForm)
    .classList.toggle('hide');
  document.querySelector(loginSelectors.loginForm).classList.toggle('hide');
}

/**
 *  Show reset password success message
 */
function resetPasswordSuccess() {
  // check if reset password form was
  // successfully submitted and show success message.
  if (document.querySelector(loginSelectors.formState)) {
    document
      .querySelector(loginSelectors.resetSuccess)
      .classList.remove('hide');
  }
}

/**
 * Initialize login form functionality
 * Called on page load and after InstantClick navigation
 */
function initLoginForm() {
  if (document.querySelector(loginSelectors.recoverPasswordForm)) {
    checkUrlHash();
    resetPasswordSuccess();

    document
      .querySelectorAll(loginSelectors.recoverPasswordFormTriggers)
      .forEach((trigger) => {
        trigger.addEventListener('click', onShowHidePasswordForm);
      });
  }
}

// Initialize on page load
initLoginForm();

// Re-initialize after InstantClick navigation
if (typeof InstantClick !== 'undefined') {
  InstantClick.on('change', function () {
    initLoginForm();
  });
}

const addressSelectors = {
  addressContainer: '[data-address]',
  addressFields: '[data-address-fields]',
  addressToggle: '[data-address-toggle]',
  addressForm: '[data-address-form]',
  addressDeleteForm: '[data-address-delete-form]',
};
const hideClass = 'hide';

function initializeAddressForm(container) {
  const addressFields = container.querySelector(addressSelectors.addressFields);
  const addressForm = container.querySelector(addressSelectors.addressForm);
  const deleteForm = container.querySelector(
    addressSelectors.addressDeleteForm
  );

  // Create or get a global overlay for address editing
  const getOrCreateOverlay = () => {
    let overlay = document.querySelector('[data-address-overlay]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.setAttribute('data-address-overlay', '');
      overlay.classList.add(hideClass);
      // Basic inline styles to ensure visibility without relying on CSS
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.right = '0';
      overlay.style.bottom = '0';
      overlay.style.background = 'rgba(0,0,0,0.5)';
      overlay.style.zIndex = '15';
      document.body.appendChild(overlay);
    }
    return overlay;
  };

  const overlay = getOrCreateOverlay();

  const toggleOverlay = (show) => {
    if (!overlay) return;
    if (show) {
      overlay.classList.remove(hideClass);
      document.body.style.overflow = 'hidden';
    } else {
      overlay.classList.add(hideClass);
      document.body.style.overflow = '';
    }
  };

  container
    .querySelectorAll(addressSelectors.addressToggle)
    .forEach((button) => {
      button.addEventListener('click', () => {
        addressForm.classList.toggle(hideClass);
        const isOpen = !addressForm.classList.contains(hideClass);
        toggleOverlay(isOpen);
      });
    });

  // Add a close "X" button to the edit address form
  const ensureCloseButton = () => {
    if (!addressForm) return;
    let closeBtn = addressForm.querySelector('[data-address-close]');
    if (!closeBtn) {
      closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.setAttribute('data-address-close', '');
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML = '&times;';
      // Basic inline styles for visibility/positioning
      closeBtn.style.position = 'absolute';
      closeBtn.style.top = '12px';
      closeBtn.style.right = '12px';
      closeBtn.style.zIndex = '15';
      closeBtn.style.background = 'transparent';
      closeBtn.style.border = 'none';
      closeBtn.style.fontSize = '24px';
      closeBtn.style.lineHeight = '1';
      closeBtn.style.cursor = 'pointer';
      // Ensure form is positioned for absolute child
      if (!addressForm.style.position) {
        addressForm.style.position = 'fixed';
      }
      addressForm.appendChild(closeBtn);
    }
    closeBtn.addEventListener('click', () => {
      addressForm.classList.add(hideClass);
      toggleOverlay(false);
    });
  };
  ensureCloseButton();

  window.Shopify.theme.addresses.AddressForm(addressFields, 'en');

  if (deleteForm) {
    deleteForm.addEventListener('submit', (event) => {
      const confirmMessage = deleteForm.getAttribute('data-confirm-message');

      if (
        !window.confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        event.preventDefault();
      }
    });
  }
}

const addressForms = document.querySelectorAll(
  addressSelectors.addressContainer
);

if (addressForms.length) {
  addressForms.forEach((addressContainer) => {
    initializeAddressForm(addressContainer);
  });
}
